import React,{useEffect,useState} from 'react'
import { useLocation } from "react-router-dom";
import { getDocs,doc ,collection} from 'firebase/firestore';
import { db } from '../../firebase';
import Img from "../../svg/userimg.png";

import Studentnav from './Studentnav';
export default function Viewstudetails() {
    const location = useLocation();
    const { compid } = location.state;
    // const [user,setUser] = useState();
    const [joblist, setJoblist] = useState([]);

  const ref = collection(db, "Industry");
  
  useEffect(() => {
    const getjob = async () => {
      const data = await getDocs(ref);
      setJoblist(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    getjob();
  },[]);
  return (
    <>
   <Studentnav/>
    {joblist.map((user)=>{
        
    
        return (user.uid==compid)?
        <section class="section about-section gray-bg " id="about">
        <div class="container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-lg-6">
                    <div class="about-text go-to">
                        <h1 class="dark-color"><mark>{user.cname}</mark></h1>
                        <h4 class="dark-color">About Company</h4>
                        <h6 class=" lead">{user.description}</h6>
                        
                        <div class="row about-list">
                            <div class="col-md-8">
                                <div class="media">
                                    <label className="ctext">Email : </label>
                                    <p className="ctext">{user.cemail}</p>
                                </div>
                                <div class="media">
                                    <label className="ctext">Contact : </label>
                                    <p className="ctext">{user.ccontact}</p>
                                </div>
                                <div class="media">
                                    <label className="ctext">Location :  </label>
                                    <p className="ctext"> {user.address}</p>
                                </div>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
               
                <div className="profile_container col-lg-6">
             <div className='img_containers'>
              <img src={user.avatar || Img} alt="avatar" className='avatar'/>
             </div>
             </div>
            </div>
           
            </div>
    </section>
        
        :null
    })}
    
    </>
  )
}
